import * as commonScripts from '../common'

const cmpBpccCharts = {
	component: null,
	
	init: function(element) {
		const _ = this
		_.component = element

		var seniorityLabelList = []
		var seniorityDataList = []
		var historicalDivdendYieldLabelList = []
		var historicalDivdendYieldLegendLHSLabel = ''
		var historicalDivdendYieldLegendRHSLabel = ''
		var historicalDivdendYieldLabelList = []
		var dividendPerShareLHSDataList1 = []
		var dividendPerShareLHSDataList2 = []
		var dividendPerShareLHSDataList3 = []
		var dividendYieldNavRHSDataList = []
		// get all chart instances on the page
		const charts = document.querySelectorAll('.bpcc-chart');

		// add the colour pallette from the home page js file
		let chartColors = [];
		for (var j = 0; j < ChartColor.length; j++)
		{
			chartColors.push(ChartColor[j].colorcode);
		}
		
		// loop over all the canvases on the page which have a class of bpcc-chart
		async function DisplayChart() {
			await getBpccData(); 
			for(const chart of charts)
			{
				const dataValuesLabels = GetChartData(chart);
				const options = getChartOptions(chart);

				const context = chart.getContext('2d');
				context.height = 'auto';
				
				let config = {
					plugins:[ChartDataLabels], 
					type: dataValuesLabels.type,
					data: dataValuesLabels.data, 
					options: options 
				};

				new Chart(context, config);

				
			}
		}

		DisplayChart()

		// get data and other settings for each chart
		function GetChartData(chartInstance) 
		{         		
			if(chartInstance.id === 'seniority-chart')
			{
				return {
					type: 'doughnut', 
					data: {
						labels: seniorityLabelList,
						datasets: [{
							backgroundColor: chartColors,
							borderColor: chartColors,
							borderWidth: 1,
							hoverBackgroundColor: chartColors,
							hoverBorderColor: chartColors,
							data: seniorityDataList
						}],
					},
				}
			}
			
			else if(chartInstance.id === 'historical-divididend-yield-mixed-chart')
			{
				return {
					type: 'bar',
					backgroundColor: chartColors, 
					borderColor: chartColors, 
					borderWidth: 1, 
					hoverBackgroundColor: chartColors, 
					hoverBorderColor: chartColors,
					data: {
						labels: historicalDivdendYieldLabelList,
						datasets: [
							{
								type: 'bar',  yAxisID: 'lhs', spanGaps: true, label: historicalDivdendYieldLegendLHSLabel, backgroundColor: ChartColor[0].colorcode, borderColor: ChartColor[2].colorcode, borderWidth: 1, hoverBackgroundColor: ChartColor[0].colorcode, hoverBorderColor: ChartColor[0].colorcode,
								data: dividendPerShareLHSDataList1
							},
							{
								type: 'bar',  yAxisID: 'lhs', spanGaps: true, label: '', backgroundColor: ChartColor[0].colorcode, borderColor: ChartColor[2].colorcode, borderWidth: 1, hoverBackgroundColor: ChartColor[0].colorcode, hoverBorderColor: ChartColor[0].colorcode,
								data: dividendPerShareLHSDataList2
							},
							{
								type: 'bar',  yAxisID: 'lhs', spanGaps: true, label: '', backgroundColor: ChartColor[0].colorcode, borderColor: ChartColor[2].colorcode, borderWidth: 1, hoverBackgroundColor: ChartColor[0].colorcode, hoverBorderColor: ChartColor[0].colorcode,
								data: dividendPerShareLHSDataList3
							},
							{
								type: 'line', yAxisID: 'rhs', spanGaps: true, label: historicalDivdendYieldLegendRHSLabel, backgroundColor: ChartColor[1].colorcode, borderColor: ChartColor[1].colorcode, borderWidth: 1, hoverBackgroundColor: ChartColor[1].colorcode, hoverBorderColor: ChartColor[1].colorcode,
								data: dividendYieldNavRHSDataList
							},
						],
					}
				}
			}
        }

        async function getBpccData() {
			const response = await window.fetch("/api/get-bpcc-financial-info")
			const data = await response.json()
			seniorityLabelList = data.SeniorityLabelList
			seniorityDataList = data.SeniorityDataList
			historicalDivdendYieldLabelList = data.HistoricalDividendYieldLabelList
			historicalDivdendYieldLegendLHSLabel = data.HistoricalDividendYieldLegendLHSLabel
			historicalDivdendYieldLegendRHSLabel = data.HistoricalDividendYieldLegendRHSLabel
			dividendPerShareLHSDataList1 = data.DividendPerShareLHSDataList1
			dividendPerShareLHSDataList2 = data.DividendPerShareLHSDataList2
			dividendPerShareLHSDataList3 = data.DividendPerShareLHSDataList3
			dividendYieldNavRHSDataList = data.DividendYieldNavRHSDataList
        }
	
		function getChartOptions(chartInstance)
		{
			if(chartInstance.id === 'seniority-chart')
			{
				return {
					responsive: true,
					maintainAspectRatio: false,
					elements: { point: { radius: 3 } }, 
					plugins: {
						legend: { position: 'bottom', labels: { generateLabels: function (theChart) { const data = theChart.data; if (data.labels.length && data.datasets.length) { return data.labels.map(function (label, i) { const meta = theChart.getDatasetMeta(0); const dataSet = data.datasets[0]; return { text: label + ' ' + dataSet.data[i] + '%', fillStyle: chartColors[i], strokeStyle: chartColors[i], lineWidth: 1, hidden: isNaN(dataSet.data[i]) || meta.data[i].hidden, index: i }; }); } return []; } } },
						tooltip: { callbacks: { label: function (context) { return context.label + ': ' + context.parsed + '%'; } } },
						datalabels: { display: false, align: function (context) { var value = context.dataset.data[context.dataIndex]; return value > 0 ? 'end' : 'start'; }, anchor: function (context) { var value = context.dataset.data[context.dataIndex]; return value > 0 ? 'end' : 'start'; }, padding: 5, color: function (context) { return context.dataset.borderColor; }, labels: { title: { font: { weight: 'bold' } } } }
					}
				}			
			}
			
			else if(chartInstance.id === 'historical-divididend-yield-mixed-chart')
			{
				return {
					responsive: true, 					
					maintainAspectRatio: false,
					elements: { point: { radius: 3 } },
					plugins: {
						tooltip: {
							callbacks: {
								label: function (context) {
									if(context.dataset.label != '')
									{
										let label = '';
										
										if(context.dataset.yAxisID === 'lhs'){
											if(context.parsed.y == 0){
												if(dividendPerShareLHSDataList2.at(context.dataIndex)){
													context.parsed.y = dividendPerShareLHSDataList2.at(context.dataIndex);
												}
												else{
													context.parsed.y = dividendPerShareLHSDataList3.at(context.dataIndex);
												}
											}
											label = context.dataset.label + ': $' + parseFloat(context.parsed.y).toFixed(2);
										}
										if(context.dataset.yAxisID === 'rhs'){
											label = context.dataset.label + ': ' + parseFloat(context.parsed.y).toFixed(2) + '%';
										}
										if (parseFloat(context.parsed.y) < 0) { label = ''; }
										return label;
									}
								}
							}
						},
						legend: {
							position: 'bottom',
							labels: {
								filter: function (item, chart) {
									// Remove legend items if the label is empty
									return !item.text == '';
								}
							},
						},
						datalabels: {
							display: true,
							align: function(context) {
								return context.datasetIndex === 3 ? 'top' : 'middle';
							},
							anchor: "middle",
							padding: 5,
							color: function(context) {
								return context.datasetIndex === 3 ? context.dataset.borderColor : '#FFFFFF';
							  },
							formatter: function (value, context) { 
								if (value) { 
									return (context.datasetIndex === 3)
									? parseFloat(value).toFixed(2) + '%'
									: '$' + parseFloat(value).toFixed(2);
								} 
							} ,
							labels: {
								title: {
									font: {
										weight: 'bold'
									}
								}
							},
				
						}
					},
					scales: {
						lhs: {
							min: 0,
							max: 0.7,
							position: 'left',
							stacked: true,
							grid: {
								display: true,
								// color: grid[0].gridColor,
								drawOnChartArea: false
							},
							title: {
								display: false,
								font: {
									size: 13,
									family: 'museo-sans,sans-serif',
									weight: 'bold'
								}
							},
							ticks: {
								stepSize: 0.1,
								callback: function (value, index, values) { return '$' + value.toFixed(2); }
							}
						},
						rhs: {
							min: 0,
							position: 'right',
							stacked: true,
							grid: {
								display: true,
								// color: grid[0].gridColor,
								drawOnChartArea: false
							},
							title: {
								display: false,
								font: {
									size: 13,
									family: 'museo-sans,sans-serif',
									weight: 'bold'
								}
							},
							ticks: {
								stepSize: 2,
								callback: function (value, index, values) { return value.toFixed(1) + '%'; }
							}
						},
						xAxis: {
							ticks: {
								stepSize: 2,
							},
							stacked: true,
							grid: {
								display: false
							},
							title: {
								display: false,
								font: {
									size: 13,
									family: 'museo-sans,sans-serif',
									weight: 'bold'
								},
							}
						}
					}
				};
			}
		}
	}
}

export default cmpBpccCharts;